import { generateId } from '../../utils/vsmGeometry';
import type { Organization } from '../../types';
import type { NewDept, NewRole, NewMember } from './types';

export function validateNewDept(newDept: NewDept, organization: Organization): string | null {
  if (!newDept.name.trim()) {
    return 'Por favor, insira o nome do setor.';
  }
  
  const nameExists = organization.departments.some(
    d => d.name.toLowerCase() === newDept.name.trim().toLowerCase()
  );
  if (nameExists) {
    return 'Já existe um setor com este nome.';
  }
  
  return null;
}

export function validateNewRole(newRole: NewRole, organization: Organization): string | null {
  if (!newRole.name.trim()) {
    return 'Por favor, insira o nome do cargo.';
  }
  if (!newRole.departmentId) {
    return 'Por favor, selecione um setor.';
  }
  
  const nameExists = organization.roles.some(
    r => r.departmentId === newRole.departmentId && 
         r.name.toLowerCase() === newRole.name.trim().toLowerCase()
  );
  if (nameExists) {
    return 'Já existe um cargo com este nome neste setor.';
  }
  
  return null;
}

export function createDepartment(newDept: NewDept) {
  return {
    id: generateId(),
    name: newDept.name.trim(),
    color: newDept.color,
    totalHeadcount: 0,
    visible: true,
    shiftMinutes: newDept.shiftMinutes || 480,
    shiftsPerDay: newDept.shiftsPerDay || 1,
  };
}

export function createRole(newRole: NewRole) {
  return {
    id: generateId(),
    name: newRole.name.trim(),
    departmentId: newRole.departmentId,
    costPerHour: Math.max(0, newRole.costPerHour),
    currency: 'BRL' as const,
    quantity: Math.max(1, newRole.quantity),
    shiftMinutes: newRole.shiftMinutes || 480,
    shiftsPerDay: newRole.shiftsPerDay || 1,
    visible: true
  };
}

export function updateDepartmentHeadcount(
  departments: Organization['departments'],
  departmentId: string,
  quantityDelta: number
) {
  return departments.map(dept => {
    if (dept.id === departmentId) {
      return { 
        ...dept, 
        totalHeadcount: Math.max(0, (dept.totalHeadcount || 0) + quantityDelta)
      };
    }
    return dept;
  });
}
